<template>
  <!--stateStorage="session"
    stateKey="dt-state-demo-session"-->
  <div>
    <DataTable  :value="listDataService" :lazy="true" class="p-datatable-responsive" selectionMode="single" data-key="id"
      @page="onPage($event)" :paginator="pagination" :totalRecords="totalRecords" :rows="paginationRows"
      :loading="loading" :first="firstRecordIndex" :scrollable="(scrollHeight !== '' ? true : false)"
      :scrollHeight="scrollHeight" :autoLayout="true" filterMatchMode="startsWith"
      :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
      :currentPageReportTemplate="$constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM + ' {totalRecords}'"
      :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
      :mode="mode">
      <Column v-for="c in model.getDisplayFields()" :key="c.key" :field="getField(c)" :header="getLabel(c)"
        :ref="getField(c)" :filterMatchMode="getFilterMatch(c)" :sortable="getSortable(c)"
        :bodyClass="(c.class ? 'txt-' + c.class : '')" :bodyStyle="getBodyStyle(c)" :headerStyle="getHeaderStyle(c)"
        :headerClass="(c.class ? 'txt-' + c.class : '')">
        <template #body="slotProps">
          <!--{{c}}-->
          <img v-if="getType(c) == 'Image'" :src="getData(c, slotProps.data)" style="width: 40px; heigth: 40px" />
          <div v-else-if="c.type == 'Text'" v-html="getData(c, slotProps.data)" :style="(c.style ? c.style : '')"></div>
          <div v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'" v-html="getData(c, slotProps.data)"
            :style="(c.style ? c.style : '')"></div>
          <div v-else-if="getType(c) == 'CustomUrl' && view_club == true" v-html="callbackCustomUrl(c, slotProps.data)"
            @click="redirectListClub(slotProps.data, $event)" :style="(c.style ? c.style : '')"></div>
          <div v-else-if="getType(c) == 'CustomUrl'" v-html="callbackCustomUrl(c, slotProps.data)"
            @click="redirectListClub(slotProps.data, $event)" :style="(c.style ? c.style : '')"></div>

          <Checkbox v-else-if="getType(c) == 'Checkbox'" v-model="slotProps.data[slotProps.column.field]" :binary="true"
            @change="onInputChange($event, slotProps.data, c)" />
          <div v-else>
            <div v-if="c.custom">
              <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge" />
              <div v-if="c.custom == 'SelectionText'" v-html="callbackDataSelect(c, slotProps.data)"></div>
            </div>
            <span v-else v-html="getData(c, slotProps.data)"
              :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
          </div>


        </template>
        <!-- <template v-if="c.filter" #filter>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          @keyup="onFilter($event,c.filter.type,c.key)"
        />
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"

          @change="onFilter($event,c.filter.type,c.key)"
        >
          <template #option="slotProps">
            <div class="p-clearfix">
              <span
                :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
            </div>
          </template>
        </Dropdown>
        <Calendar
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearRange"
          dateFormat="yy-mm-dd" 
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter calendar-light-btn"
          :showIcon="true"
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          style="width: 200px;"
          />
          
          <Calendar
          v-if="c.filter.type == 'Date'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearDOB"
          dateFormat="yy-mm-dd" 
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter calendar-light-btn"
          :showIcon="true"
          selectionMode="single"
          appendTo="body"
          :showClear="true"
          :maxDate="new Date()"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          style="width: 200px;"
          />
      </template> -->
      </Column>
      <Column v-if="actions" headerStyle="width: 10em; text-align: center"
        bodyStyle="width: 10em; text-align: center; justify-content: center">
        <template #body="slotProps">
          <span class="p-column-title">Actions</span>
          {{ slotProps.data.color }}
          <div class="style-action-click">
            <Button v-for="(a, k) in actions.rows(slotProps.data)" :key="k" type="button" :icon="getIcon(a.icon)"
              :class="getClass(a.name)" :disabled="getDisabled(a.disabled)" style="margin: 2px"
              v-on:click="actionsClicked(k, a, slotProps)"></Button>
          </div>
        </template>
        <template #header="slotProps">
          <Button v-if="actions.header" type="button" :icon="getIcon(actions.header.icon)"
            :class="getClass(actions.header.name)"
            v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"></Button>
        </template>
      </Column>
      <template #empty>
        {{ $t('datatable.empty') }}
      </template>
      <template #loading>
        {{ $t('datatable.loading') }}
      </template>
    </DataTable>
  </div>
</template>

<script>
import moment from "moment-timezone";
//import gql from "graphql-tag";
import DataServices from "@/core/DataServices";
export default {
  props: {
    mode: String,
    model: Object,
    tableData: Array,
    dataUser: {
      type: Array,
      required: true
    },
    actions: Object,
    options: Array,
    whereKeyList: Object,
    // view_club:Boolean ,
  },
  watch: {
    dataUser: {
      handler(newValue) {
        console.log('DataUser has changed:', newValue);
        // Gọi lại onLazyEvent để cập nhật bảng với dữ liệu mới
        this.onLazyEvent();
      },
      immediate: true, // Đảm bảo hàm này được gọi ngay khi component được mount
      deep: true // Theo dõi thay đổi sâu bên trong dataUser nếu là object hoặc array
    }
  },

  data() {
    return {
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService: null,
      filtersCustom: [],
      lazyParams: {},
      page_transaction: null,
      firstRecordIndex: 0,
      yearRange: (new Date().getFullYear() - 100) + ":" + (new Date().getFullYear() + 100),
      yearDOB: (new Date().getFullYear() - 100) + ":" + new Date().getFullYear(),
      time_zone_local: moment.tz.guess(true),
      view_club: false,
      dataUserTable: [],
      mode_table_display : 'add',
      id_voucher : '',
    };

  },
  async created() {
    this.id_voucher = this.$route.params.id;
    this.listDataService = this.tableData;
  },
  mounted() {
    console.log('dataUserdataUser', this.dataUser);
    console.log("this.$route.name:",this.$route.query.page_transaction);
  
    console.log('this.id_voucherthis.id_voucher',this.id_voucher);
    
    this.mode = this.$route.name === 'edit' ? 'edit' : 'add';
    this.mode_table_display = this.mode;
    
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    /*
    * stateStorage="session"
    stateKey="dt-state-demo-session"
    * phai them thuoc tinh nay vao table
    * */
    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        this.firstRecordIndex = this.lazyParams.first;
        // console.log("this.lazyParams:22222222",this.lazyParams);
        /*if (this.lazyParams){
          this.filters = (this.lazyParams.filters) ? this.lazyParams.filters : {};
        }*/
      }
    }
    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    updateTableData(newData) {
      console.log('Updating table with new dataUser:', newData);
      this.dataUserTable = [
        ...this.dataUserTable,
        ...newData.map(user => ({
          fullname: user.fullname,
          email: user.email,
          status: 'Valid',
          created_at: new Date().toLocaleDateString()
        }))
      ];
      console.log('Updated dataUserTable:', this.dataUserTable);
    }
    ,
    onRowSelect(event) {
      this.$emit('onRowSelect', event.data);
    },
    redirectListClub(data, e) {
      let clickedElId = e.target.id
      console.log(data.id)
      if (clickedElId === 'list-users-clubs') {
        var id = data.id;
        var path = `/admin/list-users_clubs/${id}`;
        this.$router.push({ path: path })
      }
    },
    callbackCustomUrl(c, data) {
      var text = ''
      switch (c.key) {
        case 'club_html':
          if (data.view_users_clubs_expiration_aggregate && data.view_users_clubs_expiration_aggregate.aggregate) {
            var count_club = data.view_users_clubs_expiration_aggregate.aggregate.count
            if (this.view_club == true) {
              text = '<a class="txt-link" id="list-users-clubs" :data-id="' + data.id + '">' + count_club + '</a>';
            } else {
              text = count_club;
            }
          } else {
            text = 0;
          }
          break;
        default:
          break;
      }
      // this.date_now
      return text;
    },
    select_date(event, col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if (col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange) f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "text-align:center;";
      if (col.width) style += "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style += "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style += "width: 6em;";
      return style;
    },
    getBodyStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "text-align:center; width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      // console.log("this.options:",this.options)
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("LL");
        // value = moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("ll HH:mm");
        // value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if (col.type == "Hour" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          // console.log("col.models:",col.models);
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter(a => a.value === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn`;
      } else if (col.filter.type == "input") {
        return `Input`;
      } else if (col.filter.type == "DateRange") {
        return `Choose`;
      } else if (col.filter.type == "Date") {
        return `Choose`;
      } else {
        return ``;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams: this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
    callbackDataSelect(c, data) {
      console.log("sasasawqwqfdf", data)
      var text = "";
      switch (c.key) {
        // key la cai name
        case 'active':
          if (data.active == true) {
            text = `<i style="color: green" class="pi pi-check icon"></i>`;
          } else {
            text = `<i style="color: red" class="pi pi-times icon"></i>`;
          }
          break;
        default:
      }
      return text;
    },
    async dataList(lazyParams) {
      console.log('aaaaaaaaaaaaaaaaaaaaa', lazyParams);
      var offset = lazyParams.first;
      var limit = lazyParams.rows;
      console.log("this.model.tableName:", this.model.tableName);
      var gqLQueryList = DataServices.getList(this.model.tableName);

      // Nếu không có id_voucher (trạng thái add), trả về mảng rỗng
      if (!this.id_voucher || this.id_voucher === "") {
        console.warn("Voucher ID is invalid or empty, returning empty list");
        return {
          listData: [],
          total: 0,
        };
      }

      // Khi id_voucher tồn tại, tiếp tục truy vấn
      var where = {
        deleted: { _eq: false },
        voucher_id: { _eq: String(this.id_voucher) }
      };

      try {
        var resData = await this.$apollo.mutate({
          mutation: gqLQueryList,
          variables: {
            where_key: where,
            offset: offset,
            limit: limit,
            orderBy: { created_at: 'desc' }
          }
        });

        var listData = resData.data[this.model.tableName];

        var gqLQueryCount = DataServices.countData(this.model.tableName);
        var countRes = await this.$apollo.mutate({
          mutation: gqLQueryCount,
          variables: {
            where_key: where
          }
        });
        var total = countRes.data[this.model.tableName + '_aggregate']['aggregate']['count'];

        var dataRes = {
          listData: listData,
          total: total,
        };

        return dataRes;
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          listData: [],
          total: 0,
        };
      }
    },
    formatDate11(date) {
      if (!date) {
        return null; // Nếu date là null hoặc không có giá trị, trả về null
      }

      // Kiểm tra xem date có ở định dạng DD/MM/YYYY không
      if (typeof date === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
        return date; // Nếu date đã ở định dạng DD/MM/YYYY, trả về trực tiếp
      }

      let d = new Date(date);
      if (isNaN(d)) {
        return null; // Nếu không thể chuyển đổi thành ngày hợp lệ, trả về null
      }

      // Lấy các phần của ngày (ngày, tháng, năm).
      let day = String(d.getDate()).padStart(2, '0'); // Đảm bảo luôn có 2 chữ số
      let month = String(d.getMonth() + 1).padStart(2, '0'); // Tháng trong JS bắt đầu từ 0
      let year = d.getFullYear();
      console.log('`${day}/${month}/${year}`', `${day}/${month}/${year}`);

      // Trả về theo format "DD/MM/YYYY"
      return `${day}/${month}/${year}`;
    },

    formatDate(date) {
      if (!date) {
        return null; // Nếu date là null hoặc không có giá trị, trả về null
      }
      let d = new Date(date);
      // Lấy các phần của ngày (ngày, tháng, năm).
      let day = String(d.getDate()).padStart(2, '0'); // Đảm bảo luôn có 2 chữ số
      let month = String(d.getMonth() + 1).padStart(2, '0'); // Tháng trong JS bắt đầu từ 0
      let year = d.getFullYear();
      console.log('`${day}/${month}/${year}`', `${day}/${month}/${year}`);

      // Trả về theo format "DD/MM/YYYY"
      return `${day}/${month}/${year}`;
    },
    // Hàm kiểm tra nếu voucher đã được sử dụng
    checkIfVoucherUsed(voucherId, userId) {
      // Thực hiện logic kiểm tra trong bảng use_voucher xem có tồn tại uid và voucher_id hay không
      // Trả về true nếu đã sử dụng, false nếu chưa
      // Ví dụ:
      return this.useVoucherList.some(item => item.voucher_id === voucherId && item.uid === userId);
    },
    onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      this.loading = true;
      var that = this;

      var stt = this.lazyParams.first;

      // Lấy dữ liệu từ API
      this.dataList(this.lazyParams).then(async (data) => {
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }

        // Xử lý dữ liệu từ API
        for (var i = 0; i < data.listData.length; i++) {
          var itemData = data.listData[i];
          stt++;
          data.listData[i].stt = stt;
          console.log('itemData:', itemData);
          
          data.listData[i].updated_by_key = itemData?.obj_updated_by?.fullname ?? '';
          data.listData[i].fullname = itemData?.users?.fullname ?? '';
          data.listData[i].email = itemData?.users?.email ?? '';
          console.log('111111111111111111111111111111', data.listData[i].voucher);
          
          if (data.listData[i].voucher.type_discount == 1) {
            data.listData[i].amount = data.listData[i].voucher.amount + '%';
          } else if (data.listData[i].voucher.type_discount == 2) {
            data.listData[i].amount = '$' + data.listData[i].voucher.amount;
            
          }
         
          data.listData[i].updated_by = itemData?.obj_updated_by?.fullname  ?? '';
          data.listData[i].created_by = itemData?.obj_created_by?.fullname  ?? '';
          
          data.listData[i].created_at = this.formatDate11(data.listData[i].created_at);
          data.listData[i].expires = this.formatDate11(data.listData[i].voucher.valid_end) ?? null;
          if (data.listData[i].status === "4") {
                data.listData[i].status = 'Deleted';
                continue; // Bỏ qua các xử lý khác và tiếp tục vòng lặp
            }
          var currentDate = new Date();
          var expiresDate = new Date(itemData.voucher.valid_end + 'T00:00:00');
          console.log('currentDate:', currentDate);
          console.log('expiresDate:', expiresDate);
          if (expiresDate < currentDate) {
            data.listData[i].status = 'Expired';
          } else if (expiresDate > currentDate) {
            data.listData[i].status = 'Valid';
          } else if (expiresDate === null || expiresDate === undefined || expiresDate == 'Invalid Date') {
            data.listData[i].status = 'Valid';
            console.log('expiresDate1111', expiresDate);
            
          }
          

     
        }




        // Lấy type_discount, amount và expires của user cuối cùng trong dataUser
        const lastUser = this.dataUser[this.dataUser.length - 1];
        console.log('Last user:', lastUser);
        
        const lastUserTypeDiscount = lastUser?.type_discount;
        const baseAmount = lastUser?.amount;
        const lastUserExpires = lastUser?.expires ?? null;
        console.log('lastUserExpireslastUserExpireslastUserExpires', lastUserExpires);
        
        // Tạo dữ liệu tạm thời từ dropdown với type_discount, amount, và expires mới nhất
        const tempDataFromDropdown = this.dataUser.map((user, index) => {
          console.log('User data:', user);

          // Cập nhật amount dựa trên type_discount của user cuối cùng
          let updatedAmount = baseAmount;
          if (lastUserTypeDiscount == 1) {
            updatedAmount = updatedAmount + '%';
          } else if (lastUserTypeDiscount == 2) {
            console.log('Amount before:', updatedAmount);
            
            updatedAmount = '$' + updatedAmount;
            
          }
          
          return {
            ...user,
            id: user.id,
            stt: stt + index + 1, // Tăng số thứ tự
            fullname: user.fullname,
            email: user.email,
            amount: updatedAmount, // Cập nhật amount theo type_discount mới nhất
            expires: this.formatDate11(lastUserExpires) ?? null, // Cập nhật expires theo user cuối cùng
            created_at: this.formatDate11(new Date()),
            status: 'Valid',
            type_discount: lastUserTypeDiscount // Đặt type_discount mới nhất
          };
        });

        console.log('lastUserTypeDiscountlastUserTypeDiscountlastUserTypeDiscount', lastUserTypeDiscount);

        // Gán dữ liệu vào listDataService dựa trên mode_table_display
        if (this.mode_table_display === 'add') {
          that.listDataService = [...tempDataFromDropdown];
        } else if (this.mode_table_display === 'edit') {
          that.listDataService = [...data.listData, ...tempDataFromDropdown];
        }




        that.totalRecords = that.listDataService.length; 
        that.loading = false;
        this.$forceUpdate();
      });
    },





    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event, type_input, key) {
      this.tableData = this.test;
      if (type_input == "DateRange") {
        if (this.filters[key] !== null && this.filters[key][1] == null) {
          return false;
        }
      }
      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input, key, this.filters);
      this.lazyParams.first = 0;
      this.onLazyEvent()
    },
  }
};
</script>
<style lang="scss">
.p-paginator-bottom {
  padding: 0 !important;
}

.p-inputtext {
  width: 100%;
}

.p-button-label {
  color: white;
}
</style>